(function($){

	$(document).ready(function(){

		$('.statistic-large, .statistic-medium').each(function(){
			$inline_css_width = $(this).width();
			$(this).css('width', $inline_css_width);
		});

		$('.counter').counterUp({
            delay: 10,
            time: 1000
        });

	});
	
})(jQuery);